<template>
    <page>
        <module height="530">
            <div class="order-state flex-between-center">
                <div>
                    <h1>{{title}}</h1>
                    <h4 style="color: yellowgreen" v-if="payment_fail && payment_fail==1 && payment_fail_reason">退款失败：{{payment_fail_reason}}</h4>
                    <p v-else>请处理售后退款申请</p>
                </div>

                <node-list :nodes="nodeList"></node-list>
            </div>

            <div class="order-detail flex">
                <dl class="order-info">
                    <dt class="flex-between-center">
                        <p>售后编号：{{afterSalesDetail.refund_number || afterSalesDetail.return_number}}</p>
                        <c-button height="26" color="gray" hollow @click="clipboard(afterSalesDetail.refund_number || afterSalesDetail.return_number)">复制</c-button>
                    </dt>
                    <dd>
                        <div class="order-info-item flex">
                            <label>关联订单：</label>
                            <p>
                                <a @click="navigateTo(`/order_detail/${afterSalesDetail.order_number}`)">{{afterSalesDetail.order_number}}</a>
                            </p>
                        </div>
                        <div class="order-info-item flex" v-if="systemConfig.pt_mode == 2 && systemConfig.operation_mode_enabled == 'ON'" >
                            <label>运营模式：</label>
                            <p>{{operationModeName[afterSalesDetail.operation_mode]}}</p>
                        </div>
                        <div class="order-info-item flex" v-if="systemConfig.pt_mode == 2 && systemConfig.stationed_authname_enabled == 'ON'"  >
                            <label>商家角色：</label>
                            <p>{{orderInfo.stationed_auth_name}}</p>
                        </div>
                        <div class="order-info-item flex" v-if="systemConfig.pt_mode == 2" >
                            <label>所属商家：</label>
                            <p>{{orderInfo.stationed_name}}</p>
                        </div>
                        <div class="order-info-item flex">
                            <label>订单状态：</label>
                            <p>
                                <span v-if="orderInfo.order_state == 1 && orderInfo.payment_state == 1" style="color:#182eff">{{orderStateName[orderInfo.order_state]}}</span>
                                <span v-if="orderInfo.order_state == 1 && orderInfo.payment_state == 2" style="color:#182eff">待付尾款</span>
                                <span v-if="orderInfo.order_state == 2" style="color:#182eff">{{orderStateName[orderInfo.order_state]}}</span>
                                <span v-if="orderInfo.order_state == 3" style="color:#69d39c">{{orderStateName[orderInfo.order_state]}}</span>
                                <span v-if="orderInfo.order_state == 5" style="color:darkgreen">{{orderStateName[orderInfo.order_state]}}</span>
                                <span v-if="orderInfo.order_state == 6" style="color:#999">{{orderStateName[orderInfo.order_state]}}</span>
                            </p>
                        </div>
                        <!-- <div class="order-info-item flex">
                            <label>退款状态：</label>
                            <p>
                                <span v-if="afterSalesDetail.refund_state == 1" style="color:grey">待退款</span>
                                <span v-else-if="afterSalesDetail.refund_state == 2" style="color:brown">退款中</span>
                                <span v-else-if="afterSalesDetail.refund_state == 3" style="color:darkgreen">已退款</span>
                                <span v-else>--</span>
                            </p>
                        </div> -->
                        <div class="order-info-item flex">
                            <label>买家账号：</label>
                            <p>{{orderInfo.user_manage_mobilephone}}</p>
                            <span v-if="orderInfo.nick_name && orderInfo.nick_name!=''">({{orderInfo.nick_name}})</span>
                        </div>
                        <div class="order-info-item flex" v-if="orderInfo.order_classify == 1 && orderInfo.receiving_name && orderInfo.receiving_phone && orderInfo.receiving_address">
                            <label>收货信息：</label>
                            <p>{{orderInfo.receiving_name}}，{{orderInfo.receiving_phone}}（{{orderInfo.receiving_address}}）</p>
                        </div>
                        <div class="order-info-item flex">
                            <label>下单时间：</label>
                            <p class="flex-grow flex-between">
                                <span>{{orderInfo.create_date}}</span>
                                <!-- <a>更多...</a> -->
                            </p>
                        </div>
                       <!-- <div class="order-info-item flex">
                            <label>已支付：</label>
                            <p v-if="orderInfo.payment_state != 2"><b>￥{{parseFloat(orderInfo.payment_money).toFixed(2)}}</b>
                                （
                                含运费：￥{{parseFloat(orderInfo.logistics_money).toFixed(2)}}
                                <span v-if="orderInfo.order_type==7 && customInfo">
                                    &nbsp;&nbsp;定制费:￥{{parseFloat(customInfo.product_price_cost_money).toFixed(2)}}
                                </span>
                                ）
                            </p>
                        </div> -->
                        <div class="order-info-item flex" v-if="afterSalesDetail.push_state == 2">
                            <label>售后三方单号：</label>
                            <p v-if="type == 'refund'">{{afterSalesDetail.out_refund_number}}</p>
                            <p v-else>{{afterSalesDetail.out_return_number}}</p>
                        </div>
                        <div class="order-info-item flex" v-if="type == 'return' && afterSalesDetail.push_state == 2">
                            <label>售后收货状态：</label>
                            <p v-if="afterSalesDetail.receiving_state == 0">待收货</p>
                            <p v-else>已收货</p>
                        </div>
                    </dd>
                </dl>

                <div class="order-node flex-grow">
                    <h1>{{afterSalesState}}</h1>
                    <div class="order-node-content">
                        <ul class="flex-wrap">
                            <li class="flex">
                                <label>申请时间：</label>
                                <p>{{afterSalesDetail.create_date}}</p>
                            </li>

                            <template v-if="type == 'refund' && afterSalesDetail.refund_type != 3">
                                <li class="flex">
                                    <label>服务退款：</label>
                                    <p>￥{{parseFloat(afterSalesDetail.product_money).toFixed(2)}}</p>
                                </li>
                                <li class="flex" v-if="orderInfo.order_classify == 1">
                                    <label>运费退款：</label>
                                    <p>￥{{parseFloat(afterSalesDetail.logistics_money).toFixed(2)}}</p>
                                </li>
                                <li class="flex" v-if="afterSalesDetail.other_fee > 0">
                                    <label>服务费退款：</label>
                                    <p>￥{{parseFloat(afterSalesDetail.other_fee).toFixed(2)}}</p>
                                </li>
                                <li class="flex" v-if="orderInfo.order_type==7 && customInfo">
                                    <label>定制费退款：</label>
                                    <p>￥{{parseFloat(customInfo.product_price_money).toFixed(2)}}</p>
                                </li>
                                <li class="flex">
                                    <label>退款原因：</label>
                                    <p>{{afterSalesDetail.refund_reason_type_name}}{{afterSalesDetail.refund_reason ? afterSalesDetail.refund_reason:''}}</p>
                                </li>
                            </template>

                            <template v-else-if="type == 'refund' && afterSalesDetail.refund_type == 3">
                                <li class="flex">
                                    <label>申请原因：</label>
                                    <p>{{afterSalesDetail.refund_reason_type_name}}{{afterSalesDetail.refund_reason ? '（'+afterSalesDetail.refund_reason+'）':''}}</p>
                                </li>
                                <li class="flex">
                                    <label>申请数量：</label>
                                    <p>{{afterSalesDetail.product_count}}</p>
                                </li>
                                <li class="flex">
                                    <label>申请退款：</label>
                                    <p>￥{{parseFloat(afterSalesDetail.refund_total_money).toFixed(2)}}</p>
                                </li>
                            </template>

                            <template v-else>
                                <li class="flex">
                                    <label>申请原因：</label>
                                    <p>{{afterSalesDetail.return_reason_type_name}}{{afterSalesDetail.return_reason ? '（'+afterSalesDetail.return_reason+'）':''}}</p>
                                </li>
                                <li class="flex">
                                    <label>申请数量：</label>
                                    <p>{{afterSalesDetail.product_count}}</p>
                                </li>
                                <li class="flex">
                                    <label>服务退款：</label>
                                    <p>￥{{parseFloat(afterSalesDetail.product_money).toFixed(2)}}</p>
                                </li>
                                <li class="flex" v-if="orderInfo.order_classify == 1">
                                    <label>运费退款：</label>
                                    <p>￥{{parseFloat(afterSalesDetail.logistics_money).toFixed(2)}}</p>
                                </li>
                            </template>

                            <li v-if="afterSalesDetail.audit_date" class="flex">
                                <label>审批时间：</label>
                                <p>{{afterSalesDetail.audit_date}}</p>
                            </li>

                            <li v-if="afterSalesDetail.audit_reject_reason" class="flex">
                                <label>驳回原因：</label>
                                <p>{{afterSalesDetail.audit_reject_reason}}</p>
                            </li>

                            <template v-if="type == 'return'">
                                <li v-if="afterSalesDetail.return_logistics_company" class="flex">
                                    <label>退回物流：</label>
                                    <p>{{afterSalesDetail.return_logistics_company}}</p>
                                </li>
                                <li v-if="afterSalesDetail.return_voucher_img_url" class="flex">
                                    <label>退回凭证：</label>
                                    <c-image class="img" :src="afterSalesDetail.return_voucher_img_url" size="40" preview></c-image>
                                </li>
                                <li v-if="afterSalesDetail.return_logistics_date" class="flex">
                                    <label>退回时间：</label>
                                    <p>{{afterSalesDetail.return_logistics_date}}</p>
                                </li>
                                <li v-if="afterSalesDetail.remitter_date" class="flex">
                                    <label>退款到账时间：</label>
                                    <p>{{afterSalesDetail.remitter_date}}</p>
                                </li>
                            </template>
                        </ul>
                    </div>
                    <div class="order-total">
                        <template v-if="type == 'refund'">
                            <!-- <span>申请数量：{{afterSalesDetail.product_count}}件</span> -->
                            <span v-if="afterSalesDetail.refund_type != 3">申请退款：￥{{(afterSalesDetail.product_money + afterSalesDetail.logistics_money + afterSalesDetail.other_fee).toFixed(2)}}</span>
                            <span v-else>申请退款：￥{{(afterSalesDetail.refund_total_money).toFixed(2)}}</span>
                            <span v-if="afterSalesDetail.state == 2">实退金额：<b>￥{{parseFloat(afterSalesDetail.refund_total_money).toFixed(2)}}</b></span>
                        </template>
                        <template v-else>
                            <span>申请数量：{{afterSalesDetail.product_count}}件</span>
                            <span>申请退款：￥{{(parseFloat(afterSalesDetail.product_money)+parseFloat(afterSalesDetail.logistics_money)).toFixed(2)}}</span>
                            <span v-if="afterSalesDetail.return_state == 5">扣款金额：<b>￥{{parseFloat(afterSalesDetail.debit_money).toFixed(2)}}</b></span>
                            <span v-if="afterSalesDetail.return_state == 5">实退金额：<b>￥{{parseFloat(afterSalesDetail.return_total_money).toFixed(2)}}</b></span>
                        </template>
                    </div>
                </div>
            </div>
        </module>

        <module>
            <div class="order-detail">
                <c-table v-model="productList" height="auto" :paging="false" border>
                    <c-table-column
                        label="服务信息"
                        width="300"
                    >
                        <template v-slot="{data}">
                            <product-info v-if="data.product_itemnumber" :image="data.product_img_url" :name="data.product_itemnumber + ' - '+data.product_name" image-size="60"></product-info>
                            <product-info v-else :image="data.product_img_url" :name="data.product_name" image-size="60"></product-info>
                        </template>
                    </c-table-column>

                    <c-table-column
                        label="规格信息"
                        name="product_sku_spec"
                    ></c-table-column>

                    <c-table-column v-if="type == 'return'"
                                    label="单价"
                    >
                        <template v-slot="{data}">
                            ￥{{parseFloat(data.product_order_unit_price).toFixed(2)}}
                        </template>
                    </c-table-column>

                    <!-- <c-table-column
                        :label="type == 'refund' ? '退款数' : '退货数'"
                    >
                        <template v-slot="{data}">
                            {{data.product_count}}
                        </template>
                    </c-table-column> -->

                    <template v-if="refundType != 3">
                        <c-table-column
                            label="退款金额"
                        >
                            <template v-slot="{data}">
                                <span style="color:dodgerblue">￥{{parseFloat(data.product_money).toFixed(2)}}</span>
                            </template>
                        </c-table-column>
                    </template>

                    <template v-if="type == 'return'">
                        <c-table-column
                            label="凭证"
                        >
                            <template v-slot="{data}">
                                <div class="flex-center-cross" v-if="data.voucher_img_arr">
                                    <c-image v-for="(medias, j) in data.voucher_img_arr" :key="j" class="img" :src="medias" size="80" preview></c-image>
                                </div>
                                <span v-else>--</span>
                            </template>
                        </c-table-column>

                        <c-table-column
                            label="扣款金额"
                        >
                            <template v-slot="{data}">
                                ￥{{parseFloat(data.debit_money).toFixed(2)}}
                            </template>
                        </c-table-column>
                    </template>
                </c-table>
            </div>

            <template slot="button">
                <template v-if="type == 'refund'">
                    <template>
                        <c-button v-if="orderInfo.operation_mode == 1 && afterSalesDetail.state == 1" size="m" power="b_order_refund_check" @click="refundVerifyHandle('resolve')">同意申请</c-button>
                        <c-button v-if="orderInfo.operation_mode == 1 &&afterSalesDetail.state == 1" size="m" power="b_order_refund_check" color="sys" @click="refundVerifyHandle('reject')">驳回申请</c-button>
                        <c-button v-if="afterSalesDetail.state == 2 && payment_fail == 1 && mq_error_log_id != 0"
                                  size="m" power="b_order_refund_check" color="red" @click="repayRefundOrder()">重新打款</c-button>
                    </template>
                </template>
                <template v-else-if="orderInfo.operation_mode == 1 && type != 'refund'">
                    <template v-if="afterSalesDetail.return_state == 1 && afterSalesDetail.return_type == 1">
                        <c-button size="m" power="b_order_return_check" @click="returnVerifyHandle('resolve')">同意申请</c-button>
                        <c-button size="m" power="b_order_return_check" color="sys" @click="returnVerifyHandle('reject')">驳回申请</c-button>
                    </template>
                    <template v-if="afterSalesDetail.return_state == 1 && afterSalesDetail.return_type == 2">
                        <div v-if="orderInfo.order_classify == 1">
                            <c-button size="m" power="b_order_return_check"  @click="checkReturnOrder()">同意申请</c-button>
                            <c-button size="m" power="b_order_return_check"  color="sys" @click="returnVerifyHandle('reject')">驳回申请</c-button>
                        </div>
                        <div v-else>
                            <c-button size="m" power="b_order_return_finance_check"  color="main" @click="returnVerifyHandle('return')">同意申请并打款</c-button>
                        </div>
                    </template>
                    <template v-else-if="afterSalesDetail.return_state == 3">
                        <c-button size="m" power="b_order_return_finance_check"  @click="returnVerifyHandle('return')">确认并打款</c-button>
                        <c-button size="m" power="b_order_return_finance_check"  color="sys" @click="returnVerifyHandle('reject')">驳回申请</c-button>
                    </template>
                </template>
            </template>
        </module>

        <c-dialog ref="rejectReason" title="驳回原因" width="550" button-name="确认驳回" @resolve="rejectHandle">
            <div class="order-verify">
                <textarea v-model="rejectReason" placeholder="请输入驳回原因..."></textarea>
            </div>
        </c-dialog>

        <c-dialog ref="returnAddress" title="同意退货" width="650" height="300" button-name="确认同意" @resolve="returnResolveHandle">
            <div class="order-verify">
                <div class="address flex-between-center">
                    <p><b>*</b>请选择退货地址：</p>
                    <div>
                        <a @click="navigateTo({name: 'm_after_sale_address'})">设置退货地址</a>
                        <a @click="getReturnAddress">刷新</a>
                    </div>
                </div>

                <c-radio-group v-model="returnAddress" column>
                    <c-radio v-for="(item, i) in returnAddressOptions" :key="i" :value="item.value">{{item.name}}</c-radio>
                </c-radio-group>
            </div>
        </c-dialog>

        <c-dialog ref="returnDebit" title="售后服务扣款" width="1000" button-name="确认并打款" @resolve="returnRemitHandle">
            <c-table ref="returnDebitList" v-model="debitList" height="400" :paging="false">
                <c-table-column
                    label="服务信息"
                    width="200"
                >
                    <template v-slot="{data}">
                        <product-info v-if="data.product_itemnumber" :image="data.product_img_url" :name="data.product_itemnumber + ' - '+data.product_name" image-size="60"></product-info>
                        <product-info v-else :image="data.product_img_url" :name="data.product_name" image-size="60"></product-info>
                    </template>
                </c-table-column>

                <c-table-column
                    label="规格信息"
                    name="product_sku_spec"
                ></c-table-column>

                <c-table-column
                    label="单价"
                >
                    <template v-slot="{data}">
                        ￥{{data.product_order_unit_price}}
                    </template>
                </c-table-column>

                <c-table-column
                    :label="type == 'refund' ? '退款数' : '退货数'"
                >
                    <template v-slot="{data}">
                        ×{{data.product_count}}
                    </template>
                </c-table-column>

                <c-table-column
                    label="实付金额"
                >
                    <template v-slot="{data}">
                        ￥{{data.product_money}}
                    </template>
                </c-table-column>

                <template v-if="type == 'return'">
                    <c-table-column
                        label="凭证"
                    >
                        <template v-slot="{data}">
                            <div  class="flex-center-cross" v-if="data.voucher_img_arr">
                                <c-image v-for="(medias, j) in data.voucher_img_arr" :key="j" class="img" :src="medias" size="80" preview></c-image>
                            </div>
                            <span v-else>--</span>
                        </template>
                    </c-table-column>

                    <c-table-column
                        label="扣款金额"
                        v-if="(orderInfo.order_classify == 1)"
                    >
                        <template v-slot="{data}">
                            <c-input v-model="data.debit_money" type="number" decimal="2" :limit="data.product_money"></c-input>
                        </template>
                    </c-table-column>

                    <c-table-column
                        label="实退金额"
                    >
                        <template v-slot="{data}">
                            ￥{{parseFloat((data.product_money - (parseFloat(data.debit_money) || 0)).toFixed(2))}}
                        </template>
                    </c-table-column>
                </template>
            </c-table>
        </c-dialog>
    </page>
</template>

<script>
import nodeList from '@/components/public/node_list.vue'
import productInfo from '@/components/public/product_info.vue'
import {mapState} from 'vuex'

export default {
    components: {
        nodeList, productInfo
    },

    props: {
        type: String,
        afterSalesNumber: String,
        refundType: String
    },

    data() {
        return {
            orderStateName: {
                1: '待付款',
                2: '待发货',
                3: '待收货',
                5: '交易完结',
                6: '已关闭'
            },
            operationModeName: {
                1: '平台自营',
                2: '商家自营',
                3: '采购供货'
            },
            afterSalesDetail: {},
            orderInfo: {},
            customInfo: {},
            preOrderInfo: {},
            productList: [],

            returnAddressList: [],
            returnAddress: '',
            rejectReason: '',
            debitList: [],
            return_type:0, //1=退货退款;2=仅退款
            mq_error_log_id:0,//MQ错误消息ID
            payment_fail:0,
            payment_fail_reason:''
        }
    },

    computed: {
        ...mapState(['systemConfig']),

        orderState() {
            return {
                1: '待付款',
                2: '待发货',
                3: '待收货',
                5: '交易完结',
                6: '已关闭'
            }[this.orderInfo.order_state];
        },

        afterSalesState() {
            if (this.type == 'refund') {
                return {
                    1: '待审核',
                    2: '审核通过',
                    3: '已驳回',
                    4: '已撤销'
                }[this.afterSalesDetail.state];
            } else {
                return {
                    1: '待审核',
                    2: '待用户退货',
                    3: '待财务打款',
                    5: '退款成功',
                    6: '已驳回',
                    8: '已撤销'
                }[this.afterSalesDetail.return_state];
            }
        },
        title(){
            var result = "";
            if (this.type == 'refund'){
                result = "未发退款";
            }else {
                if (this.return_type == 1){
                    result = "【已发】退货退款（需要寄回服务）";
                }else {
                    result = "【已发】仅退款（无需寄回服务）";
                }
            }
            return result;
        },
        nodeList() {
            if (this.type == 'refund') {
                //退款单状态   1-待审核  、 2 审核通过  、 3 已驳回 、4 已撤销
                let state = this.afterSalesDetail.state;
                if (state == 3){
                    return [{
                        name: '提交申请'
                    }, {
                        name: '申请驳回'
                    }];
                }else if(state == 4){
                    return [{
                        name: '提交申请'
                    }, {
                        name: '申请撤销'
                    }];
                }else {
                    return [{
                        name: '提交申请'
                    }, {
                        name: '退款审批',
                        current: state == 1
                    }, {
                        name: '退款完结',
                        current: state == 1
                    }];
                }
            } else {
                //申请状态   1-待审核、  2：待用户退货 、3：待财务打款、5 退款成功、 6 申请驳回 、 8：申请撤销
                let state = this.afterSalesDetail.return_state;
                console.log(state)
                if (state == 6){
                    return [{
                        name: '提交申请'
                    }, {
                        name: '申请驳回'
                    }];
                }else if(state == 8){
                    return [{
                        name: '提交申请'
                    }, {
                        name: '申请撤销'
                    }];
                }else{
                    if (this.return_type == 2){
                        return [{
                            name: '提交申请'
                        }, {
                            name: '退货审批',current: state == 1
                        }, {
                            name: '财务审批',current: state == 3
                        }, {
                            name: '退款完结', current: state == 3
                        }];
                    }else {
                        return [{
                            name: '提交申请'
                        }, {
                            name: '退货审批',current: state == 1
                        }, {
                            name: '买家退货',current: state == 2
                        }, {
                            name: '财务审批',current: state == 3
                        }, {
                            name: '退款完结', current: state == 3
                        }];
                    }
                }
            }
        },

        returnAddressOptions() {
            return Array.from(this.returnAddressList, item => {
                return {
                    name: `${item.after_sale_name}，${item.after_sale_mobile}，${item.after_sale_address}`,
                    value: item.id
                }
            });
        }
    },

    watch: {
        afterSalesNumber() {
            this.getAfterSalesDetail();
        }
    },

    mounted() {
        this.getAfterSalesDetail();
    },

    methods: {
        getAfterSalesDetail() {
            this.request({
                url: this.type == 'refund' ? '/refund/detail' : '/returns/detail',
                data: {
                    [this.type == 'refund' ? 'refund_number' : 'return_number']: this.afterSalesNumber,
                },
                loading: true,
                success: data => {
                    this.afterSalesDetail = data.base_info;
                    this.orderInfo = data.order_info;
                    this.customInfo = data.custom_info;
                    this.preOrderInfo = data.pre_order_info;
                    this.productList = data.product_info || data.return_product_list;
                    this.return_type = data.base_info.return_type||1;
                    this.mq_error_log_id = data.mq_error_log_id||0;
                    this.payment_fail = data.payment_fail||0;
                    this.payment_fail_reason = data.payment_fail_reason||'';
                }
            });
        },

        refundVerifyHandle(type, confirm) {
            if (type == 'resolve') {
                this.$confirm({
                    text: '确定要对该退款单立即执行退款操作吗？',
                    resolve: () => {
                        this.request({
                            url: '/refund/approval',
                            data: {
                                refund_number: this.afterSalesNumber
                            },
                            loading: true,
                            success: () => {
                                this.$message({
                                    text: '订单退款成功',
                                    icon: 'success'
                                });
                                this.getAfterSalesDetail();
                                this.$bus.$emit('refund.update', {});
                            }
                        });
                    }
                });
            } else if (confirm) {
                this.request({
                    url: '/refund/reject',
                    data: {
                        refund_number: this.afterSalesNumber,
                        refund_reject_reason: this.rejectReason.trim()
                    },
                    loading: true,
                    success: () => {
                        this.$message({
                            text: '申请驳回成功',
                            icon: 'success'
                        });
                        this.getAfterSalesDetail();
                        this.$bus.$emit('refund.update', {});
                    }
                });
            } else {
                this.rejectHandle();
            }
        },
        /***
         重新发起退款
         */
        repayRefundOrder() {
            this.$confirm({
                text: '是否确定重新发起退款打款申请？',
                resolve: () => {
                    this.request({
                        url: '/refund/repay',
                        data: {
                            mq_error_log_id:this.mq_error_log_id,
                            refund_number: this.afterSalesNumber
                        },
                        loading: true,
                        success: () => {
                            this.$message({
                                text: '重新打款申请发起成功，请稍候查询打款状态',
                                icon: 'success'
                            });
                            this.getAfterSalesDetail();
                            this.$bus.$emit('refund.update', {});
                        }
                    });
                }
            });
        },

        //仅退款的收货单
        checkReturnOrder(){
            this.$confirm({
                text: '是否确认同意售后单【'+this.afterSalesNumber+'】进行仅退款？',  // 提示内容,
                buttonName: '确定',  // 确定按钮文字
                cancelButton: true,  // 是否显示取消按钮
                resolve: () => {
                    this.request({
                        url: '/returns/check',
                        data:{
                            return_number: this.afterSalesNumber,
                            return_state: 3 //待财务打款
                        },
                        loading: true,
                        success: () => {
                            this.$message({
                                text: '操作成功',
                                icon: 'success'
                            });
                            this.getAfterSalesDetail();
                        }
                    });
                },  // 确定按钮回调
                cancel: () => {},  // 取消按钮回调
            });
        },

        returnVerifyHandle(type, confirm) {
            if (type == 'resolve' && !confirm) {
                this.returnResolveHandle();
                return;
            } else if (type == 'reject' && !confirm) {
                this.rejectHandle();
                return;
            } else if (type == 'return' && !confirm) {
                this.returnRemitHandle();
                return;
            }

            let returnAddress;
            if (type == 'resolve') {
                returnAddress = this.returnAddressList.find(item => item.id == this.returnAddress);
            }

            this.request({
                url: '/returns/check',
                data: Object.assign({
                    return_number: this.afterSalesNumber,
                    return_state: type == 'return' ? 5 : type == 'reject' ? 6 : 2,
                    audit_reject_reason: this.rejectReason.trim(),
                    return_skus: type == 'return' ? Array.from(this.debitList, item => {
                        return {
                            product_sku: item.product_sku,
                            debit_money: parseFloat(item.debit_money) || 0
                        }
                    }) : ''
                }, type == 'resolve' ? {
                    return_after_sale_name: returnAddress.after_sale_name,
                    return_after_sale_mobile: returnAddress.after_sale_mobile,
                    return_after_sale_address: returnAddress.after_sale_address
                } : {}),
                loading: true,
                success: () => {
                    this.$message({
                        text: '操作成功'
                    });
                    this.getAfterSalesDetail();
                }
            });
        },

        returnResolveHandle(stop) {
            if (!stop) {
                if (!this.returnAddressOptions.length) {
                    this.getReturnAddress();
                }
                this.returnAddress = '';
                this.$refs.returnAddress.open();
            } else {
                stop();

                if (!this.returnAddress) {
                    this.$message({
                        text: '请选择退货地址'
                    });
                    return;
                }

                this.returnVerifyHandle('resolve', true);
                this.$refs.returnAddress.close();
                this.$bus.$emit('return.update', {});
            }
        },

        getReturnAddress() {
            this.request({
                url: '/after_sale_address/list',
                data: {
                    pageIndex: 1,
                    pageSize: 20,
                    state: [2]
                },
                loading: true,
                success: data => {
                    this.returnAddressList = data;
                }
            });
        },

        returnRemitHandle(stop) {
            if (!stop) {
                this.request({
                    url: '/returns/detail',
                    data: {
                        return_number: this.afterSalesNumber,
                    },
                    loading: true,
                    success: data => {
                        this.debitList = data.return_product_list;
                        this.$refs.returnDebit.open();
                    }
                });
            } else {
                stop();

                var total = 0;
                this.debitList.forEach(item => {
                    total += parseFloat(item.debit_money) || 0;
                });

                this.$confirm({
                    text: `确定要对该退货退款单立即执行打款操作吗？<br>(申请金额:￥${(this.afterSalesDetail.product_money+this.afterSalesDetail.logistics_money).toFixed(2)}，实退金额:<span style="color: #f00">￥${(this.afterSalesDetail.product_money + this.afterSalesDetail.logistics_money - parseFloat(total.toFixed(2))).toFixed(2)}</span>)`,
                    resolve: () => {
                        this.returnVerifyHandle('return', true);
                        this.$refs.returnDebit.close();
                        this.$bus.$emit('return.update', {});
                    }
                });

            }
        },

        rejectHandle(stop) {
            if (!stop) {
                this.rejectReason = '';
                this.$refs.rejectReason.open();
            } else {
                stop();

                if (!this.rejectReason.trim()) {
                    this.$message({
                        text: '请填写驳回原因'
                    });
                    return;
                }

                this[`${this.type}VerifyHandle`]('reject', true);
                this.$refs.rejectReason.close();
                this.$bus.$emit('return.update', {});
            }
        }
    }
}
</script>

<style lang="stylus" scoped>
@import '~@/assets/style/theme'

.order {
    &-state {
        height: 120px;
        padding: 0 34px;
        color: #fff;
        background: #622F8A;
        background-image: url('~@/assets/image/order_detail_state_bg.png');
        background-size: 100% auto;
        background-position: left bottom;
        background-repeat: no-repeat;

        h1 {
            font-size: 24px;
        }

        p {
            font-size: 13px;
            margin-top: 15px;
        }
    }

    &-detail {
        padding: 30px;
    }

    &-info {
        width: 38%;
        border: 1px solid #ddd;

        dt {
            height: 42px;
            border-bottom: 1px solid #ddd;
            padding: 0 12px 0 16px;

            p {
                font-size: 13px;
                font-weight: bold;
            }
        }

        dd {
            padding: 12px 25px 12px 18px;
        }

        &-item {
            padding: 6px 0;
            line-height: 20px;
            font-size: 12px;

            label {
                min-width: 5em;
                color: #666;
                text-align: right;
            }

            p {
                a {
                    color: #003DD9;
                }
            }

            .tag {
                border-radius: 2px;
                padding: 0 5px;
                margin-left: 6px;
                line-height: 18px;
                color: #fff;
            }
        }
    }

    &-node {
        border: 1px solid #ddd;
        border-left: none;
        padding: 0 20px;

        h1 {
            line-height: 106px;
            font-size: 24px;
            font-weight: normal;
            text-align: center;
        }

        &-content {
            padding: 30px 0 40px 14%;
            background: #FAFAFA;

            li {
                box-sizing: border-box;
                width: 50%;
                padding: 8px 20px 8px 0;
                line-height: 20px;
                font-size: 13px;

                label {
                    min-width: 7em;
                    color: #666;
                    text-align: right;
                }

                p {
                    a {
                        color: #003DD9;
                    }
                }
            }
        }
    }

    &-total {
        padding: 16px 0;
        font-size: 13px;
        text-align: right;

        span {
            margin-left: 2em;
        }

        b {
        theme-color(main);
        }
    }

    &-verify {
        padding: 20px;

        .address {
            font-size: 13px;

            b {
                margin-right: 4px;
                color: #f00;
            }

            a {
                margin-left: 15px;
                color: #003DD9;
            }
        }

        .c-radio-group {
            margin: 20px 0;
        }

        textarea {
            box-sizing: border-box;
            width: 100%;
            height: 120px;
            border: none;
            padding: 10px 14px;
            line-height: 20px;
            background: #FAFAFA;
            resize: none;
        }
    }
}

.product {
    &-info {
        margin-left: 18px;
        line-height: 24px;
        font-size: 12px;
        color: #444;
    }
}

.logistics {
    &-order {
        padding: 14px 18px;

        li {
            border: 1px solid #ddd;
            padding: 0 26px;
            line-height: 42px;
            font-size: 14px;
            color: #666;
            cursor: pointer;

            &:nth-child(n+2) {
                margin-left: 20px;
            }

            &:hover {
                background: #F0F3FC;
            }

            &.z-crt {
                border-color: #005CD9;
                color: #005CD9;
                background: #F0F3FC;
            }
        }
    }

    &-list {
        height: 434px;
        padding: 20px;
        overflow: auto;
        background: #FAFAFA;

        li {
            padding: 10px 0;
            line-height: 24px;
            font-size: 13px;
            color: #333;

            label {
                margin-right: 16px;
                color: #666;
            }
        }
    }
}
</style>